import React from 'react'
import { PieChart, Pie, Cell, Tooltip } from 'recharts'

export default function RankedDonutCard({ title, centerLabel, centerValue, data, size = 160, action }) {
  const radius = size / 2

  return (
    <div className="w-full h-full rounded-2xl border border-border-lines p-4">
      <div className="flex items-center justify-between mb-3">
        <p className="text-base font-semibold text-dark-blue">{title}</p>
        {action}
      </div>

      <div className="flex items-center gap-6">
        <div className="relative shrink-0" style={{ width: size, height: size }}>
          <PieChart width={size} height={size}>
            <Pie
              data={data}
              dataKey="percent"
              nameKey="label"
              cx={radius}
              cy={radius}
              innerRadius={radius * 0.62}
              outerRadius={radius}
              paddingAngle={2}
              stroke="none"
              isAnimationActive={false}
            >
              {data.map((entry) => <Cell key={entry.label} fill={entry.color} />)}
            </Pie>
            <Tooltip formatter={(value) => `${value}%`} />
          </PieChart>

          {
            (centerLabel || centerValue) && (
              <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
                {centerValue && <p className="text-sm font-bold text-dark-blue text-center leading-tight">{centerValue}</p>}
                {centerLabel && <p className="text-xs text-secondary text-center">{centerLabel}</p>}
              </div>
            )
          }
        </div>

        <div className="flex-1 min-w-0 flex flex-col gap-3">
          {
            data.map((entry) => (
              <div key={entry.label} className="flex items-center justify-between gap-2 text-sm">
                <span className="flex items-center gap-2 text-secondary truncate">
                  <span className="w-2.5 h-2.5 rounded-full shrink-0" style={{ backgroundColor: entry.color }} />
                  <span className="truncate">{entry.label}</span>
                </span>
                <span className="text-dark-blue font-medium shrink-0">{entry.percent}%</span>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  )
}
